export default __webpack_public_path__ + "static/media/book.63cc04b7.svg";